import IAccessToken from "../../IAccessToken";
import { Link, Outlet, useLocation } from "react-router-dom";
import SellerTabs from "./SellerTabs";
import { sellerUrlTab, SellersUrl } from "./sellersUrls";

const SellerPage = (
    {
        accessTokenO,
        sellerId
    }: {
        accessTokenO: IAccessToken | null;
        sellerId: string;
    }
) => {
    const fullPath = useLocation().pathname;
    const currentRoute = fullPath.substring(SellersUrl.length + 36 + 2 /* // + guid size */);
    return (
        <div>
            <div className='tabs'>
                <ul>
                    { SellerTabs
                        .filter((tab) => tab.filter(accessTokenO?.authUserO))
                        .map((tab, index) =>
                            <li key={`t-${index}`}
                                className={currentRoute === tab.path ? 'is-active' : ''}>
                                <Link to={sellerUrlTab(sellerId, tab.path)}> { tab.title } </Link>
                            </li>
                        )
                    }
                </ul>
            </div>

            <div className='p-margin-4'>
                <Outlet context={{accessTokenO}}/>
            </div>
        </div>
    );
}

export default SellerPage;